
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import conf from "./../../config/base.js";
import { routerNames, invoiceTitleType } from "@/common/js/const.js";
import { setToken, getToken } from "@/common/js/common.js";
import regexpValid from "@/common/js/regexp.js";
import Box from 'vux/src/components/box/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Countdown from 'vux/src/components/countdown/index.vue'


export default {
name: routerNames.LoginScan,
components: {
Box,
Alert,
Group,

Cell,




XHeader,
XButton,
XInput,
XTextarea,
Search,
Countdown
},
data() {
return {
isWechat: ____isWechatBrowser(),
topHeight: ____hasHeader ? "46px" : "0px",

mobile: "",
validCode: "",





showView: 1,
state: "",
rid: "",
time: 60,
start: false,
showCode: true,
showCount: false,
qrSrc: ""
};
},
created() {},
activated() {
var $self = this;
var queryStr = $self.getRequest();
$self.code = queryStr.code;
var state = queryStr.state;
if (state != undefined && state.indexOf("_") > -1) {
var arr = state.split("_");
if (arr.length == 2) {
$self.state = arr[0];
$self.rid = arr[1];
}
}
if (conf.envType == 'PROD') {
$self.qrSrc = "/xforce/static/common/imgs/e-invoice-qrcode.jpg";
} else {
$self.qrSrc = "/xforce/static/common/imgs/e-invoicemanager-qrcode.jpg";
}
$self.subscribeUserInfo();
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {},
/**初始化的时候调用  类似于 ready */
mounted() {},
methods: {

subscribeUserInfo() {
var $self = this;
const dataJ = {
code: $self.code,
state: $self.state
};
$self.$webapi.subscribeUserInfo(dataJ).then(res1 => {
$self.$clog(res1.data);
if (res1.data.status == 1) {

setToken(res1.data.token);
$self.jsapiLoad();
$self.queryPhone();
} else if (res1.data.status == 0) {

$self.showView = 1;
}
});
},

queryPhone() {
var $self = this;
$self.$webapi.ifBindMobilePhone().then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {

$self.showView = 3;
} else {

$self.showView = 2;
}
});
},

jsapiLoad() {
var $self = this;
if ($self.isWechat) {

$self.$webapi.getJsapiSign().then(res => {
$self.$clog(res.data);
window.wx.config({
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.signature, // 必填，签名，见附录1
jsApiList: [

"scanQRCode"
]
});
});
}
},

userWechatScanQRCode() {
var $self = this;
if ($self.isWechat) {
window.wx.ready(function() {
window.wx.scanQRCode({
needResult: 1,
desc: "scanQRCode desc",
success: function(res) {




var result = res.resultStr;
if (result.indexOf("/login/wxbridge") > -1) {
var radomn = "";
if (result.indexOf("?") != -1) {
radomn = result.substr(result.indexOf("rid=") + 4);
}
$self.$router.replace({
path: "/login/wxbridge",
query: { rid: radomn }
});
} else if (result.indexOf("http")) {
window.location.href = result;
} else {
window.wx.closeWindow();
}
}
});
});
}
},

getValidCode() {
var $self = this;
if (!$self.$refs.input_mobile_phone.valid) {
$self.alert("提示", "请输入手机号码");
return;
}
$self.$webapi.getValidCodeForBindMobile($self.mobile).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.showCode = false;
$self.showCount = true;
$self.start = true;
} else {
$self.alert("提示", res.data.msg);
}
});
},

login() {
var $self = this;
$self.$webapi.userLoginByQrcode($self.rid).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.loginAlert("登录成功", "欢迎使用票税助手桌面版");
} else {
$self.loginAlert("登录失败", res.data.msg);
}
});
},
loginAlert(t, c) {
var $self = this;
$self.$vux.alert.show({
title: t,
content: c,
onShow() {

},
onHide() {


if ($self.isWechat) {
window.wx.closeWindow();
} else {
window.opener = null;
window.close();
}
}
});
},


bindMobile() {
var $self = this;
if (!$self.$refs.input_valid_code.valid) {
$self.alert("提示", "请输入验证码");
return;
}
$self.$webapi.bindMobilePhone($self.validCode, $self.mobile).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {

$self.$vux.alert.show({
title: "绑定成功",
content: "即将打开微信扫一扫",
onShow() {

},
onHide() {

$self.userWechatScanQRCode();
}
});
} else {
$self.alert("绑定失败", res.data.msg);
}
});



},
alert(t, c) {
this.$vux.alert.show({
title: t,
content: c,
onShow() {
console.log("Plugin: I'm showing");
},
onHide() {
console.log("Plugin: I'm hiding now");
}
});
},
getRequest() {
var url = location.search;
url = url.split("#")[0];
var theRequest = new Object();
if (url.indexOf("?") != -1) {
var str = url.split("?")[1];
var strs = str.split("&");
for (var i = 0; i < strs.length; i++) {
theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
}
}
return theRequest;
},
finish2(index) {
this.start = false;
this.showCode = true;
this.showCount = false;

}
}
};
